<template>
  <swiper-content isProduct :contentEnabled="contentEnabled">
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout page-layout-product">
          <img src="./products/ipad-image.png" class="product-image" />
          <div class="content">
            <img
              src="./products/ipad-logo.svg"
              class="product-logo"
              style="margin-top: -1.2vh; max-width: 22%"
            />

            <h2>
              Delightfully capable. <br />
              Surprisingly affordable.
            </h2>
            <p>
              iPad combines a 10.2-inch Retina display, powerful A12 Bionic chip
              and the tremendous capability of iPadOS 14, there’s even more to
              love about iPad.
            </p>
            <a
              target="_blank"
              href="https://shop.singtel.com/phones/apple-ipad-8th-gen/space-grey-32gb-xo-78?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=ipad8gen-buynow&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button"
            >
              Buy Now
            </a>
            <a
              target="_blank"
              href="https://www.singtel.com/personal/products-services/mobile/info/ipad8-gen?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=ipad8gen-learnmore&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button"
            >
              Learn More
            </a>

            <p class="small">T&amp;Cs apply.</p>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  name: "IpadPage",
  data: function () {
    return {};
  },
  props: {
    contentEnabled: Boolean,
  },
  methods: {},
};
</script>

<style scoped></style>
